// src/components/map/utils/mapExtentPolygon.ts
//
// Pure helper for building a GeoJSON polygon from map-extent coordinates.
// Extracted from the inline polygon construction in MapboxWrapper's `onMapMove`.

/**
 * Build a GeoJSON Polygon representing the rectangular map extent
 * defined by the south-west and north-east corners.
 *
 * The winding order is counter-clockwise (SW → SE → NE → NW → SW)
 * which follows the GeoJSON right-hand rule for exterior rings.
 *
 * @param sw - The south-west corner as `{ lng: number; lat: number }`.
 * @param ne - The north-east corner as `{ lng: number; lat: number }`.
 * @returns A GeoJSON Polygon geometry.
 */
export function buildMapExtentPolygon(
  sw: { lng: number; lat: number },
  ne: { lng: number; lat: number }
): GeoJSON.Polygon {
  const xmin = sw.lng;
  const ymin = sw.lat;
  const xmax = ne.lng;
  const ymax = ne.lat;

  return {
    type: "Polygon",
    coordinates: [
      [
        [xmin, ymin],
        [xmax, ymin],
        [xmax, ymax],
        [xmin, ymax],
        [xmin, ymin]
      ]
    ]
  };
}
